module.exports = __webpack_public_path__ + "static/media/Skrelp_gaussian2.a49a8081.png";